import {
  PHONE_NUMBER_SEARCH_FAILURE,
  PHONE_NUMBER_SEARCH_REQUEST,
  PHONE_NUMBER_SEARCH_SUCCESS,
  PHONE_NUMBER_SEARCH_RESET,
} from '../actions/search_phone_number'

export const searchPhoneNumberTransactions = (
  state = {
    isFetching: false,
    errorMessage: null,
    count: 0,
  },
  action
) => {
  switch (action.type) {
    case PHONE_NUMBER_SEARCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case PHONE_NUMBER_SEARCH_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        count: action.response.count,
      }
    case PHONE_NUMBER_SEARCH_FAILURE:
      return {
        ...state,
        errors: null,
        isFetching: false,
        errorMessage: action.error,
      }
    case PHONE_NUMBER_SEARCH_RESET:
      return {
        ...state,
        errors: null,
        isFetching: false,
        errorMessage: null,
        count: 0,
      }
    default:
      return state
  }
}
